import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #ffd1dc 0%, #ffb6c1 100%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  overflow: hidden;
`;

const LoadingText = styled(motion.h2)`
  font-size: 2rem;
  color: #d84079;
  margin-top: 2rem;
  font-weight: 700;
  text-align: center;
`;

const LoveText = styled(motion.div)`
  font-size: 1.2rem;
  color: #fff;
  margin-top: 1.5rem;
  font-weight: 500;
  text-align: center;
  max-width: 80%;
  line-height: 1.6;
  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
`;

const HeartContainer = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
`;

const Heart = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ff4b8d;
  transform: rotate(45deg);

  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #ff4b8d;
    border-radius: 50%;
  }

  &:before {
    top: -50%;
    left: 0;
  }

  &:after {
    top: 0;
    left: -50%;
  }
`;

const FloatingHeart = styled(motion.div)`
  position: absolute;
  font-size: ${props => props.size || '2rem'};
  color: ${props => props.color || '#ff4b8d'};
  z-index: 2;
  filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
`;

const LoadingScreen = () => {
  // Create multiple floating hearts positions
  const floatingHearts = [
    { id: 1, top: '15%', left: '10%', size: '1.5rem', color: '#ff4b8d', delay: 0 },
    { id: 2, top: '25%', left: '80%', size: '2rem', color: '#ff69b4', delay: 0.5 },
    { id: 3, top: '60%', left: '15%', size: '1.8rem', color: '#ff1493', delay: 0.3 },
    { id: 4, top: '70%', left: '75%', size: '1.6rem', color: '#ff4b8d', delay: 0.7 },
    { id: 5, top: '35%', left: '90%', size: '1.2rem', color: '#d84079', delay: 0.1 },
    { id: 6, top: '80%', left: '30%', size: '1.7rem', color: '#ff69b4', delay: 0.9 }
  ];
  
  return (
    <LoadingContainer>
      {floatingHearts.map(heart => (
        <FloatingHeart
          key={heart.id}
          style={{ 
            top: heart.top, 
            left: heart.left,
            fontSize: heart.size,
            color: heart.color
          }}
          animate={{
            y: [0, -20, 0],
            x: [0, 10, 0],
            rotate: [0, 10, -10, 0],
            scale: [1, 1.2, 1]
          }}
          transition={{
            duration: 3 + heart.delay,
            repeat: Infinity,
            delay: heart.delay
          }}
        >
          💖
        </FloatingHeart>
      ))}
      
      <HeartContainer>
        <Heart
          animate={{
            scale: [0.8, 1, 0.8],
            opacity: [0.8, 1, 0.8],
            rotateY: [0, 180, 360],
            boxShadow: [
              '0 0 20px rgba(255, 75, 141, 0.5)',
              '0 0 40px rgba(255, 75, 141, 0.8)',
              '0 0 20px rgba(255, 75, 141, 0.5)'
            ]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </HeartContainer>
      
      <LoadingText
        animate={{
          opacity: [0.5, 1, 0.5],
          scale: [0.98, 1.02, 0.98],
          textShadow: [
            '0 0 5px rgba(255, 105, 180, 0.3)',
            '0 0 20px rgba(255, 105, 180, 0.5)',
            '0 0 5px rgba(255, 105, 180, 0.3)'
          ]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        در حال بارگذاری پیام عاشقانه...
      </LoadingText>
      
      <LoveText
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        دلآرام عزیزم، یک لحظه صبر کن، تمام عشقم را برایت آماده می‌کنم
      </LoveText>
    </LoadingContainer>
  );
};

export default LoadingScreen; 